import { Component, Vue, Watch } from 'vue-property-decorator';
import template from './invoices.vue';
import apiService from '@/services/api.service';
import { nl, enUS } from 'date-fns/locale';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { config } from '@/definitions/config';
import { format } from 'date-fns';
import dateFormat from 'dateformat';
import { LocalUser, Action } from '@/store/store.definitions';
import { moneySeperator } from '@/utilities';
import { Invoice } from '@/definitions';

@Component({
  mixins: [template],
})
export default class Invoices extends Vue {
  invoices: Invoice[] = [];

  async mounted(): Promise<void> {
    try {
      this.invoices = await apiService.getInvoices();
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.invoices.retrieve_error', type: 'danger' });
    }
  }

  readableDate(date: string): string {
    return format(new Date(date), 'PPPP', { locale: this.$i18n.locale === 'nl' ? nl : enUS });
  }

  get user(): LocalUser {
    return this.$Store.state.user;
  }

  getMoneyString(amount: number): string {
    return `€ ${moneySeperator(amount.toString(), this.$i18n.locale)}`;
  }

  generatePDF(invoiceId: string): void {
    const invoice = this.invoices.find(i => i.id === invoiceId);
    if (invoice) {
      const price = this.getPrice(+invoice.amount.value);
      const pdfName = `PleqqieRekening_${invoice.id.replace('tr_', '')}`;
      const doc: any = new jsPDF();
      doc.addImage(config.LOGO, 'PNG', 15, 10, 48, 15);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Klant:', 15, 40);
      doc.text('Klantreferentie:', 15, 45);
      doc.text('Rekening ID:', 15, 50);
      doc.text('Datum betaling:', 15, 55);
      doc.setFont('helvetica', 'normal');
      doc.text(this.user.company, 45, 40);
      doc.text(invoice.customerId, 45, 45);
      doc.text(invoice.id, 45, 50);
      doc.text(dateFormat(new Date(invoice.paidAt), 'dd-mm-yyyy'), 45, 55);
      const tableStyle = {
        theme: 'plain',
        alternateRowStyles: {
          fontStyle: 'bold'
        },
        columnStyles: {
          1: {
            halign: 'right'
          },
          2: {
            halign: 'right'
          }
        }
      };

      let nextMonthDate = new Date(new Date(invoice.createdAt));
      nextMonthDate = new Date(nextMonthDate.setMonth(nextMonthDate.getMonth() + 1));
      nextMonthDate = new Date(nextMonthDate.setDate(nextMonthDate.getDate() - 1));

      doc.autoTable({
        body: [
          ['Omschrijving', 'Periode', 'Bedrag in EUR'],
          [
            'Maandelijkse kosten',
            `${format(new Date(invoice.createdAt), 'PP', { locale: nl })} t/m ${format(nextMonthDate, 'PP', { locale: nl })}`,
            price.incl],
          ['Totaal incl. BTW', '', price.incl]
        ],
        startY: 80,
        ...tableStyle
      });

      doc.autoTable({
        body: [
          ['Totaal excl. BTW', 'Bedrag in EUR'],
          [`21% over ${price.excl}`, price.btw],
          [`Totaal inclusief ${price.btw} BTW in EUR`, price.incl]
        ],
        startY: 120,
        ...tableStyle
      });

      doc.text('Het totaalbedrag inclusief BTW is afgeschreven van de rekening met IBAN NL21RABO0806142815.', 15, 160);
      doc.text('De afschrijving wordt gedaan door Developers House', 15, 165);

      doc.setFontSize(7);
      doc.setFont('helvetica', 'bold');
      doc.text('Developers House B.V.', 15, 265);
      doc.setFont('helvetica', 'normal');
      doc.text('Postadres: Anthony van Hobokenstraat 7, 3161 KR Rhoon', 15, 269);
      doc.text('IBAN: NL12 INGB 0664 5706 66', 15, 273);
      doc.text('BTW: NL0092.63.470.B.01', 15, 277);
      doc.text('KvK: Rhoon, 27127960', 15, 281);

      doc.save(pdfName + '.pdf');
    }
  }

  getPrice(price: number): { incl: string, excl: string, btw: string } {
    const excl = +((price / 1.21).toFixed(2))
    return {
      incl: price.toFixed(2).replace('.', ','),
      excl: `${excl}`.replace('.', ','),
      btw: (price - excl).toFixed(2).replace('.', ',')
    };
  }
}